var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { Accordion } from './Accordion';
import { BoldText, ContentContainer, ContentInfoContainer, HeaderText, Image, Info, Title, } from './Common';
import ptKUrl from '../images/PT Kindergarten.gif';
import ptG1Url from '../images/PT G1.gif';
import ptG2Url from '../images/PT G2.gif';
import ptG3Url from '../images/PT G3.gif';
import ptG4Url from '../images/PT G4.gif';
import ptG5Url from '../images/PT G5.gif';
var PlacementTestAccordion = function (_a) {
    var grade = _a.grade, rest = __rest(_a, ["grade"]);
    return (_jsx(Accordion, __assign({}, rest, { tooltipContent: 'The checkbox will be checked after at least 1 student takes the Placement Test', label: 'Placement Test', header: _jsx(HeaderText, { children: "Upon first login, students complete the Placement Test and start learning" }, void 0) }, { children: _jsx(Content, { grade: grade }, void 0) }), void 0));
};
var ScImage = styled(Image).withConfig({ displayName: "ScImage", componentId: "sc-1fizqho" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 510px;\n  height: 287px;\n  border: 1px solid #d7dde4;\n  border-radius: 8px;\n"], ["\n  width: 510px;\n  height: 287px;\n  border: 1px solid #d7dde4;\n  border-radius: 8px;\n"])));
var ScInfo = styled(Info).withConfig({ displayName: "ScInfo", componentId: "sc-ekgade" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  text-align: left;\n"], ["\n  text-align: left;\n"])));
var ScContentInfoContainer = styled(ContentInfoContainer).withConfig({ displayName: "ScContentInfoContainer", componentId: "sc-uyyxgx" })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", " {\n    margin-right: 0;\n    margin-bottom: 32px;\n  }\n"], ["\n  ", " {\n    margin-right: 0;\n    margin-bottom: 32px;\n  }\n"])), function (_a) {
    var down = _a.theme.down;
    return down('tablet');
});
var ScContentContainer = styled(ContentContainer).withConfig({ displayName: "ScContentContainer", componentId: "sc-1dnty60" })(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", " {\n    flex-flow: column;\n  }\n"], ["\n  ", " {\n    flex-flow: column;\n  }\n"])), function (_a) {
    var down = _a.theme.down;
    return down('tablet');
});
var Content = function (_a) {
    var grade = _a.grade;
    var imageUrl = getImageByGrade(grade);
    return (_jsxs(ScContentContainer, { children: [_jsxs(ScContentInfoContainer, { children: [_jsx(Title, { children: "Students are ready to begin! Their curriculum will be assigned automatically." }, void 0), _jsxs(ScInfo, { children: ["By default, your class is assigned ", grade, " curriculum. Upon first login, students will take the ", _jsx(BoldText, { children: "Placement Test" }, void 0), ". It takes 20-30 min to complete and consists of 20 multiple choice questions.", _jsx("br", {}, void 0), "Based on the results, students will enter the curriculum at the point that is right for them."] }, void 0)] }, void 0), _jsx(ScImage, { src: imageUrl, alt: 'grade image', loading: 'lazy' }, void 0)] }, void 0));
};
var getImageByGrade = function (grade) {
    var url = '';
    switch (grade) {
        case 'Grade 1':
            url = ptG1Url;
            break;
        case 'Grade 2':
            url = ptG2Url;
            break;
        case 'Grade 3':
            url = ptG3Url;
            break;
        case 'Grade 4':
            url = ptG4Url;
            break;
        case 'Grade 5':
            url = ptG5Url;
            break;
        case 'K':
        default:
            url = ptKUrl;
            break;
    }
    return url;
};
export { PlacementTestAccordion };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
